module.exports = __webpack_public_path__ + "static/media/work (13).64145d24.jpg";